"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _storeMapa = _interopRequireDefault(require("../stores/store-mapa"));

// Dynamically moves the docs when the order is adjusted
var CollectionMapa =
/*#__PURE__*/
function (_StoreMapa) {
  (0, _inherits2.default)(CollectionMapa, _StoreMapa);

  function CollectionMapa() {
    (0, _classCallCheck2.default)(this, CollectionMapa);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CollectionMapa).apply(this, arguments));
  }

  (0, _createClass2.default)(CollectionMapa, [{
    key: "_getProp",
    value: function _getProp(doc, name) {
      return doc.getValue(name);
    }
  }, {
    key: "_setProp",
    value: function _setProp(doc, name, value) {
      return doc.getField(name).setValue(value);
    }
  }]);
  return CollectionMapa;
}(_storeMapa.default);

exports.default = CollectionMapa;